import Config from '@/utils/config'
import Storage from '@/utils/storage'
import store from '@/store'
import Ajax from '@/utils/ajax'

const getDefaultState = () => {
  return {
    status: 0, // 0 init, 1: config error, 2 : connection error, 3 : success
    config: {
      theme: '',
      showRegister: false,
      canChooseEnv: false,
      envList: []
    },
    isconnected: false,
    selectedEnvIndex: localStorage.getItem('selectedEnvIndex') || 0,
    selectedEnv: []
  }
}

const state = getDefaultState()

const mutations = {
  TANGO_LOADCONFIG: (state, config) => {
    state.config = config
    if (state.config.envList && state.config.envList.length) {
      let i = 1
      state.config.envList = state.config.envList.map(item => Object.assign({}, {label: item.name, value: i++}, item))
    }
  },
  TANGO_CONNECT: (state, val) => {
    state.isconnected = val
  },
  TANGO_SELECTED: (state, val) => {
    state.selectedEnv = val
  },
  TANGO_SELECTED_INDEX: (state, val) => {
    state.selectedEnvIndex = val
    localStorage.setItem('selectedEnvIndex', val)
  },
  TANGO_CLOSE: () => {
    // state.config = {
    //   canChooseEnv: false,
    //   envList: []
    // }
  },
  SET_TANGO_STATUS: (state, status) => {
    state.status = status
  },
  SET_THEME: (state, theme) => {
    state.theme = theme
    localStorage.setItem('stark-theme', theme)
  },
  SET_SHOWREGISTER: (state, showRegister) => {
    state.showRegister = showRegister
    localStorage.setItem('stark-showRegister', showRegister)
  },
  RESET_STORE: (state) => {
    let config = Object.assign({}, state.config)
    Object.assign(state, getDefaultState())
    state.config = config
  }
}

const actions = {
  loadConfig({ commit, state }, self) {
    let fileName = (process.env.NODE_ENV !== 'production') ? '/config.json.sample' : '/config.json'
    return Ajax.get(fileName).then(rep => JSON.parse(rep.response)).then(cfg => {
      let config = Config.load(cfg)
      if (!config) {
        commit('TANGO_LOADCONFIG', {})
        commit('SET_TANGO_STATUS', 1) // missing config
        throw new Error('Error : Missing config')
      }
      else {
        self.addMessagesHandler()
        return config
      }
    }).then(config => {
      commit('TANGO_LOADCONFIG', config)
      if (state.selectedEnv.length === 0) {
        let idx = localStorage.getItem('selectedEnvIndex') || 0
        commit('TANGO_SELECTED_INDEX', idx)
        commit('TANGO_SELECTED', config['envList'][idx])
      }
      let env = state.selectedEnv
      Storage.setKey(env.name)
      let themeName = config.theme ? config.theme : 'dark-theme'
      let theme = Storage.getItem('stark-theme', themeName)
      commit('SET_THEME', theme || themeName)

      let showRegister = typeof config.showRegister !== 'undefined' ? config.showRegister : false
      commit('SET_SHOWREGISTER', showRegister)

      commit('SET_TANGO_STATUS', 3) // tango Connection Success S06: FIXME
    }).catch(error => {
      commit('TANGO_LOADCONFIG', {})
      self.removeMessagesHandler()
      throw new Error(error || '[TANGO] connection')
    })
  },
  connect({ commit }, val) {
    commit('TANGO_CONNECT', val)
  },
  close({ commit, state }, self) {
    if (state.status === 3) {
      return (store.state.user.userInfos.netId && self.$tango.isConnected()) ? self.$tango.logOut().then(() => {
        commit('TANGO_CLOSE')
        return self.$tango.close()
      }).catch(error => {
        // eslint-disable-next-line
        console.log(error)
        Promise.reject(new Error('error') || 'Error : Logout')
      }) : self.$tango.close()
    }
  },
  setStatus({ commit }, status) {
    commit('SET_TANGO_STATUS', status)
  },
  toggleShowRegister({ commit }, val) {
    commit('SET_SHOWREGISTER', val)
  },
  setTheme({ commit }, theme) {
    commit('SET_THEME', theme)
  },
  setTangoEnv: ({commit, state}, idx) => {
    if (!state.config.envList || state.config.envList.length === 0) return null
    let env = idx < state.config.envList.length ? state.config.envList[idx] : state.config.envList[0]
    commit('TANGO_SELECTED_INDEX', idx)
    commit('TANGO_SELECTED', env)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
